"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isThenable = void 0;

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if argument is thenable
 */
var isThenable = function isThenable(maybePromise) {
  return !!(maybePromise && (0, _isFunction.default)(maybePromise.then) && (0, _isFunction.default)(maybePromise.catch));
};

exports.isThenable = isThenable;
//# sourceMappingURL=is-thenable.js.map